export default "__VITE_ASSET__Vw70zZ95__"